import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const PersonAddSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default PersonAddSVG;
